import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { routes } from '../../../../utils/helpers/ApiClient';
import MenuBar from './MenuBar';
import { useTranslation } from 'react-i18next';
import Form from '../../../antd/form/Form/Form';
import FormTextField from '../../../antd/form/FormTextField/FormTextField';
import { required } from '../../../antd/form/FormValidation';
import FormButton from '../../../antd/form/FormButton/FormButton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLoginMutation } from '../../../../redux/services/authApi';
import { WRONG_CREDENTIALS_MESSAGE } from '../../../../utils/constants/common_constants.js';
import FormPasswordField from '../../../antd/form/FormPasswordField/FormPasswordField.jsx';

const LoginModal = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [login, { isError, isSuccess }] = useLoginMutation();

  useEffect(() => {
    if (isSuccess)
      navigate(
        location.state?.from ? location.state.from : routes.cmsDashboard,
      );
  }, [isSuccess]);

  const renderForm = () => {
    const initials = {
      login: undefined,
      password: undefined,
    };

    return (
      <Form
        initialValues={initials}
        onFinish={(values) =>
          login({
            login: values.login,
            password: values.password,
          })
        }
      >
        <MenuBar />

        <FormTextField
          label={t('Prihlasovacie meno')}
          name="login"
          rules={[required(t)]}
          autoFocus
        />

        <FormPasswordField
          label={t('Heslo')}
          type="password"
          name="password"
          rules={[required(t)]}
          visibletoggle={'true'}
        />

        <div className="forgotten-password-wrapper">
          <span className="forgotten-text">{t('Zabudol som heslo:')}</span>
          <div className="forgotten-options">
            <Link to="/stranka/zmena-ldap-hesla" className="forgotten-link">
              {t('Som FRI zamestnanec/študent')}
            </Link>
            <Link to="/zabudnute-heslo" className="forgotten-link">
              {t('Som externý používateľ')}
            </Link>
          </div>
        </div>

        {isError && (
          <span className="incorrect-credentials">
            {t(WRONG_CREDENTIALS_MESSAGE)}
          </span>
        )}

        <div className="login-button-container">
          <FormButton submitOnClick={true} submitKey={'login'}>
            {t('Prihlásiť')}
          </FormButton>
        </div>
      </Form>
    );
  };

  const { t } = useTranslation();

  return (
    <div>
      <Modal
        open={location && location.pathname === routes.loginPage}
        //onCancel={() => navigate(-1)}
        onCancel={() => navigate(routes.homePage)}
        footer={null}
        className="login-modal-wrapper"
      >
        {renderForm(t)}
      </Modal>
    </div>
  );
};

export default LoginModal;
